import { message } from "antd";
import axiosInstance from "./axiosInstance";

interface LoginData {
  username: string;
  password: string;
}

export const loginApi = async (data: LoginData) => {
  try {
    const response = await axiosInstance.post("/oauth/admin-login", data);
    const { token, user } = response.data;

    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));

    return response.data;
  } catch (error: any) {
    message.error(error.response?.data?.systemMessage || "Đăng nhập thất bại!");
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

export const getAuthToken = () => localStorage.getItem("token");
